import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Card, CardContent, CardActions, Button, Snackbar, Alert } from '@mui/material';
import { BASE_URL } from 'api/axios';

// Material Dashboard 2 React components
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

// Material Dashboard 2 React example components
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';

// Data
import reportsLineChartData from 'layouts/dashboard/data/reportsLineChartData';


function Dashboard() {
  const { sales, tasks } = reportsLineChartData;

  const [deliverStatus, setDeliverStatus] = useState(false); // assume default false
  const [snack, setSnack] = useState({ open: false, message: '', severity: 'success' });

  const userId = localStorage.getItem("userId");
  const userRole = localStorage.getItem("userRole");
  const authConfig = () => {
    const token = localStorage.getItem("token");
    return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
  };

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const res = await axios.get(`${BASE_URL}deliver/getbyid/${userId}`, authConfig());
        const driver = res.data?.data || res.data;
        setDeliverStatus(Boolean(driver?.deliverstatus));
      } catch (err) {
        console.error(err);
      }
    };
    fetchStatus();
  }, []);

  // Function to toggle status
  const handleStatusToggle = async () => {
    try {
      const newStatus = !deliverStatus;
      await axios.put(`${BASE_URL}deliver/${userId}/status`, { deliverStatus: newStatus }, authConfig());
      setDeliverStatus(newStatus);
      setSnack({
        open: true,
        message: `Deliver marked as ${newStatus ? 'Available' : 'Not Available'}`,
        severity: 'success',
      });
    } catch (error) {
      console.error(error);
      setSnack({
        open: true,
        message: 'Failed to update status',
        severity: 'error',
      });
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <MDTypography variant="h4" fontWeight="medium">
          Welcome to JCGN-Delivery Service
        </MDTypography>

        {/* Deliver Status Card */}
        {userRole === "deliver" && (
          <Card
            sx={{
              mt: 4,
              backgroundColor: deliverStatus ? '#d0f0c0' : '#fddede', // light green or light red
              transition: '0.3s',
              borderRadius: 2,
              boxShadow: 3,
            }}
          >
            <CardContent>
              <MDTypography variant="h6" fontWeight="bold">
                Deliver Status: {deliverStatus ? 'Available' : 'Not Available'}
              </MDTypography>
              <MDTypography variant="body2" color="text.secondary">
                Click the button below to change your availability status.
              </MDTypography>
            </CardContent>
            <CardActions>
              <Button
                variant="contained"
                color={deliverStatus ? 'error' : 'success'}
                onClick={handleStatusToggle}
              >
                Set as {deliverStatus ? 'Not Available' : 'Available'}
              </Button>
            </CardActions>
          </Card>
        )}
        {/* Snackbar */}
        <Snackbar
          open={snack.open}
          autoHideDuration={3000}
          onClose={() => setSnack({ ...snack, open: false })}
        >
          <Alert
            onClose={() => setSnack({ ...snack, open: false })}
            severity={snack.severity}
            sx={{ width: '100%' }}
          >
            {snack.message}
          </Alert>
        </Snackbar>
      </MDBox>
    </DashboardLayout>
  );
}

export default Dashboard;
